import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import '../css/style.css';
import '../components/Home.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { getURL } from '../backend/Backend';
import { translate } from "react-i18next";
import AuthenticationService from '../backend/AuthenticationService';
import WarningInfo from '../components/util/WarningInfo';



class StartLayout extends Component {

  constructor(props) {
    super(props);
    this.searchEvents = this.searchEvents.bind(this);
    this.pageChanged = this.pageChanged.bind(this);
    this.selectItem = this.selectItem.bind(this);
    this.goBack = this.goBack.bind(this);
    this.onSelectTab = this.onSelectTab.bind(this);
    this.loadWarning = this.loadWarning.bind(this);


    this.state = {
      events: [],
      selected: '',
      warning: null,
      activePage: 1,
      totalPages: 0,
      criteria: '',
      showResult: false,
      tabindex: 0
    };
  }

  async componentDidMount() {
    if (!(!this.state.showResult && this.props.children)) {
      let c = { 'eventCategory': 'ALL' };
      this.searchEvents(c, 1);
    }
    this.loadWarning();
  }

  async pageChanged(e) {
    this.searchEvents(this.state.criteria, e.target.text);
  }

  async searchEvents(criteria, page) {

    if (!page) {
      return;
    }
    if ("<" === page) {
      page = --this.state.activePage;
    }
    if (">" === page) {
      page = ++this.state.activePage;
    }

    let isPublicEvent = this.checkPublicEvent(criteria);
    let searchService = isPublicEvent ? 'p-events' : 'events';
   
    let converted = criteria.eventCategory ? criteria.eventCategory : '';
    converted += "--";
    converted += criteria.subCategory ? criteria.subCategory : '';
    converted += "--";
    converted += criteria.city ? criteria.city : '';
    converted += "--";
    converted += criteria.startDate ? criteria.startDate : '';

    const response = await fetch(getURL(`${searchService}/search/${converted}/${page - 1}`));
    const json = await response.json();
  
    let oldState = this.state;
    this.setState({
      ...oldState,
      events: json.content,
      selected: '',
      totalPages: json.totalPages,
      activePage: page,
      criteria: criteria,
      showResult: true
      //warning: newWarning
    });

  }


  checkPublicEvent(criteria) {
    return (this.props.searchType === 'PUBLIC' || (criteria && criteria.searchType === 'PUBLIC')) || (!this.props.searchType && (!criteria || !criteria.searchType)) ? true : false;
  }

  selectItem(e) {
    let oldState = this.state;

    this.setState({
      ...oldState,
      selected: e.id
    })
  }

  goBack() {
    let oldState = this.state;

    this.setState({
      ...oldState,
      selected: ''
    })
  }

  onSelectTab(tabindex) {
    let oldState = this.state;
    this.setState({
      ...oldState,
      tabindex: tabindex
    });
  }

  async loadWarning() {
    const response = await fetch(getURL(`infoEntity/load/de`));
    const json = await response.json();
    let oldState = this.state;
    this.setState({
      ...oldState,
      warning: json
    });

  }



  render() {
    const { t } = this.props;
    let user = AuthenticationService.getLoggedUser();
    let isPublicEvent = this.checkPublicEvent(null);
    let createLink = isPublicEvent ? 'pubEventAdd' : 'eventAdd';
    let createLabel = isPublicEvent ? 'CreatePublicEvent' : 'ActivityErstellen';
    let cssClass = isPublicEvent ? 'primary' : 'success';

    return (
      <div id="container">
        <div id="header"><Header eventKey={this.props.eventKey} bg={this.props.bg} bgStrong={this.props.bgStrong} /></div>
        <div id="body" >
          <Row className={"mt-3"}>
            <Col xl={2} xs={12} >

              <Row>
                <Col>
                  <p>Hier kommt werbung Startseite...</p>
                </Col>
              </Row>
            </Col>

            <Col xl={8} xs={12}  >
              {(this.state.warning && this.state.warning.active)  ?
                <Row>
                  <Col>
                    <WarningInfo warning={this.state.warning} />
                  </Col>
                </Row>
                : ''
              }

              {this.props.children}
            </Col>
            <Col xl={2} xs={6} >
              <p>Hier kommt werbung Startseite...</p>
            </Col>
          </Row>

        </div>
        <div id="footer"><Footer /></div>
      </div>
    );

  }

}

export default translate("translations")(StartLayout);